module.exports = __webpack_public_path__ + "static/media/grin-beam.f4473d60.svg";